// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Contribution } from './contribution';
import { ContributionBatch } from './contribution-batch';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ContributionCash extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: string;
  batchId?: number;
  cash1!: number;
  cash10!: number;
  cash100!: number;
  cash2!: number;
  cash20!: number;
  cash5!: number;
  cash50!: number;
  coin1!: number;
  coin10!: number;
  coin100!: number;
  coin25!: number;
  coin5!: number;
  coin50!: number;
  contributionId?: number;
  batch!: ContributionBatch;
  contribution!: Contribution;
}

